import React from 'react';
import { Button } from '@mui/material';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';

function ZoomControls({ onZoom }) {
  return (
    <div
      style={{
        position: 'absolute',
        bottom: 16,
        right: 16,
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '50px',
        gap: '8px',
      }}
    >
      <Button onClick={() => onZoom('in')} variant="contained">
        <ZoomInIcon />
      </Button>
      <Button onClick={() => onZoom('out')} variant="contained">
        <ZoomOutIcon />
      </Button>
    </div>
  );
}

export default React.memo(ZoomControls);
